import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from 'ngx-bootstrap/alert';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EngagementPlanModalComponent } from './components/engagement-plan-modal/engagement-plan-modal.component';
import { NgModule } from '@angular/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { ResetMobileAppPasswordComponent } from './components/reset-mobile-app-password/reset-mobile-app-password.component';
import { ResidentFormsComponent } from './components/resident-forms/resident-forms.component';
import { ResidentHeaderComponent } from './components/resident-header/resident-header.component';
import { ResidentSnapshotModalComponent } from './components/resident-snapshot-modal/resident-snapshot-modal.component';
import { RouterModule } from '@angular/router';
import { TranscriptionsComponent } from './components/transcriptions/transcriptions.component';
import { UiModule } from '@modules/ui/ui.module';

@NgModule({
  declarations: [
    ResidentHeaderComponent,
    ResidentFormsComponent,
    TranscriptionsComponent,
    ResetMobileAppPasswordComponent,
    EngagementPlanModalComponent,
    ResidentSnapshotModalComponent,
  ],
  exports: [
    ResidentHeaderComponent,
    ResidentFormsComponent,
    TranscriptionsComponent,
  ],
  imports: [
    CommonModule,
    UiModule,
    RouterModule,
    NgbAccordionModule,
    NgScrollbarModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    AlertModule,
  ],
})
export class SharedModule {}
